import gql from 'graphql-tag';

export const ALLCATEGORIAS = gql`
    query {
        categorias{
            _id
            orden
            nombre
        }
    }
`;

export const GETCATEGORIA = gql`
    query getCategoria($id:String){
        categoria(id:$id){
            _id
            orden
            nombre
        }
    }
`;

export const NEWCATEGORIA = gql`
    mutation ($cat:String){
        newCategoria(cat:$cat)
    }
`;

export const EDITCATEGORIA = gql`
    mutation ($id:String, $cat:String){
        editCategoria(id:$id cat:$cat)
    }
`;

export const ALLSUBCATEGORIAS = gql`
    query getSubcategorias{
        subcategorias{
            _id
            nombre
            orden
            categoria{
                _id
                nombre
            }
        }
    }
`;

export const GETSUBCATEGORIA = gql`
    query getSubcategoria($id:String){
        subcategoria(id:$id){
            _id
            orden
            nombre
            categoria{
                _id
                nombre
            }
        }
    }
`;

export const NEWSUBCATEGORIA = gql`
    mutation ($subcat:String){
        newSubcategoria(subcat:$subcat)
    }
`;

export const EDITSUBCATEGORIA = gql`
    mutation ($id:String, $subcat:String){
        editSubcategoria(id:$id, subcat:$subcat)
    }
`;


